package com.klantenstop.web.pages.authentication.companyRegistration

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.klantenstop.web.navigation.Navigation
import com.klantenstop.web.navigation.unauthenticatedGuard
import com.klantenstop.web.pages.authentication.components.AuthenticationContainer
import com.klantenstop.web.utils.Res
import com.klantenstop.web.utils.decodeReturnUrl
import com.klantenstop.web.utils.format
import com.materialkobweb.utils.rememberViewModel
import com.materialkobweb.components.DsPageLayout
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.onMouseOver
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLElement

@Page("/bedrijf-registreren")
@Composable
fun RegisterPage() = unauthenticatedGuard {
    val pageContext = rememberPageContext()

    // Use constant key to maintain ViewModel across navigation
    val viewModel = rememberViewModel(cached = false) { CompanyRegistrationViewModel() }
    val state by viewModel.state.collectAsState()

    // Get the terugNaar query parameter and decode from base64
    val returnTo = pageContext.route.params["terugNaar"]?.let { encodedUrl ->
        decodeReturnUrl(encodedUrl)
    } ?: Navigation.Screen.Home.route

    LaunchedEffect(Unit) {
        viewModel.effect.collect { event ->
            when (event) {
                CompanyRegistrationContract.Effect.NavigateToNextScreen -> pageContext.router.navigateTo(
                    pathQueryAndFragment = returnTo,
                    updateHistoryMode = UpdateHistoryMode.REPLACE
                )
            }
        }
    }

    CompanyRegistrationPageContent(
        returnToUrl = returnTo,
        state = state,
        sendIntent = viewModel::sendIntent
    )
}

@Composable
private fun CompanyRegistrationPageContent(
    returnToUrl: String,
    state: CompanyRegistrationContract.State,
    sendIntent: (CompanyRegistrationContract.Intent) -> Unit
) {

    DsPageLayout(
        modifier = Modifier.fillMaxSize(),
        title = Res.String.DocumentTitle.format("Registreren"),
        header = {},
        overflowMenu = {},
        overflowMenuOpened = false,
        footer = {},
        sidePanel = {},
    ) {
        AuthenticationContainer(
            title = "Registreren - Company",
            content = {
                SpanText(
                    modifier = Modifier,
                    text = "Voer jou ondernemingsnummer in zodat we zeker zijn dat we een uniek account kunnen aanmaken voor jou."
                )

//                Column(
//                    modifier = Modifier.fillMaxWidth(),
//                    verticalArrangement = Arrangement.spacedBy(16.px, Alignment.CenterVertically)
//                ) {
//                    Row(
//                        modifier = Modifier.fillMaxWidth(),
//                        horizontalArrangement = Arrangement.spacedBy(16.px),
//                        verticalAlignment = if (!state.showCompanyNumberError.isNullOrBlank()) Alignment.CenterVertically else Alignment.Bottom
//                    ) {
//                        Column(
//                            modifier = Modifier.fillMaxWidth()
//                        ) {
//                            DsEditableField(
//                                modifier = Modifier.fillMaxWidth(),
//                                id = "inputVatNumber",
//                                label = "Ondernemingsnummer",
//                                placeholder = "BE0xxx.xxx.xxx of BE1xxx.xxx.xxx",
//                                value = state.companyNumber,
//                                valid = state.isCompanyNumberValid != false,
//                                readOnly = state.companyCheckResponse != null,
//                                onValueChange = { sendIntent(CompanyRegistrationContract.Intent.UpdateCompanyNumber(it)) },
//                                required = true,
//                                backgroundColor = colorScheme.surfaceContainer,
//                                focusBorderColor = colorScheme.primary.toRgb().copyf(alpha = 0.6f)
//                            )
//
//                            if (state.showCompanyNumberError != null) {
//                                SpanText(
//                                    text = state.showCompanyNumberError,
//                                    modifier = Modifier
//                                        .padding(left = 8.px, top = 2.px)
//                                        .fontSize(12.px)
//                                        .color(colorScheme.onSurfaceVariant)
//                                )
//                            }
//                        }
//
//                        FilledIconButton(
//                            modifier = Modifier,
//                            onClick = {
//                                if (state.companyCheckResponse != null) {
//                                    sendIntent(CompanyRegistrationContract.Intent.Reset)
//                                } else {
//                                    sendIntent(CompanyRegistrationContract.Intent.CheckValidityOfCompanyNumber)
//                                }
//                            }
//                        ) {
//                            DsMaterialSymbols(
//                                icon = if (state.companyCheckResponse != null) "refresh" else "search"
//                            )
//                        }
//                    }
//                }
//
//                if (state.companyCheckResponse != null) {
//                    ReadOnlyAddressArea(
//                        companyName = state.companyCheckResponse.companyName ?: "",
//                        streetName = state.companyCheckResponse.address?.streetName ?: "",
//                        streetNumber = state.companyCheckResponse.address?.streetNumber ?: "",
//                        postalCode = state.companyCheckResponse.address?.zipCode ?: "",
//                        city = state.companyCheckResponse.address?.city ?: "",
//                        country = state.companyCheckResponse.address?.country ?: "",
//                        isAutoFilled = true
//                    )
//
//                    if (!state.companyCheckResponse.unknown) {
//                        SpanText(
//                            modifier = Modifier.fillMaxWidth(),
//                            text = "Dit bedrijf heeft al een account en is ook al geverifieerd. In het geval dat dit niet correct kan je hier de toegang aanvragen of je kan een mail sturen naar info@klantenstop.be"
//                        )
//
//                        HorizontalDivider(modifier = Modifier.fillMaxWidth())
//
//                        SpanText(
//                            modifier = Modifier.fillMaxWidth()
//                                .fontSize(20.px),
//                            text = "Toegang aanvragen"
//                        )
//
//                        SpanText(
//                            modifier = Modifier.fillMaxWidth(),
//                            text = "Vul hieronder nog enkele gegevens in om de toegang aan te vragen."
//                        )
//
//                        RequestCompanyAccessForm(
//                            validateFields = state.showValidation,
//                            onFormDataChanged = { sendIntent(CompanyRegistrationContract.Intent.UpdateRequestAccessFormData(it)) },
//                            onCommit = { sendIntent(CompanyRegistrationContract.Intent.RequestAccess) }
//                        )
//                    } else {
//                        HorizontalDivider(modifier = Modifier.fillMaxWidth())
//
//                        RegisterForm(
//                            validateFields = state.showValidation,
//                            onFormDataChanged = { sendIntent(CompanyRegistrationContract.Intent.UpdateFormData(it)) },
//                            onCommit = { sendIntent(CompanyRegistrationContract.Intent.CompanyRegistration) }
//                        )
//                    }
//                }
//
//                FilledButton(
//                    modifier = Modifier.fillMaxWidth(),
//                    type = ButtonType.Submit,
//                    enabled = (state.companyCheckResponse?.unknown == false && state.requestAccessFormData?.isValid == true) || state.formData?.isValid == true,
//                    onClick = {
//                        if (state.companyCheckResponse?.unknown == false) {
//                            sendIntent(CompanyRegistrationContract.Intent.RequestAccess)
//                        } else {
//                            sendIntent(CompanyRegistrationContract.Intent.CompanyRegistration)
//                        }
//                    }
//                ) {
//                    Text(
//                        if (state.companyCheckResponse?.unknown == false) {
//                            "Toegang aanvragen"
//                        } else {
//                            "Account aanmaken"
//                        }
//                    )
//                }
            },
            footer = {
                Text("Ben je al bekend bij ons? ")
                Link(
                    modifier = authLinkModifier,
                    path = Navigation.Screen.Login(returnToUrl).route,
                    updateHistoryMode = UpdateHistoryMode.REPLACE,
                    text = "Log dan in"
                )
                Text(" of wil je toch liever ")
                Link(
                    modifier = authLinkModifier,
                    path = Navigation.Screen.Register(returnToUrl).route,
                    updateHistoryMode = UpdateHistoryMode.REPLACE,
                    text = "een persoonlijk account aanmaken?"
                )
            })
    }
}

// TODO: Replace with a proper style solution
val authLinkModifier = Modifier
    .fontWeight(FontWeight.Bold)
    .textDecorationLine(TextDecorationLine.Underline)
    .onMouseOver {
        (it.currentTarget as? HTMLElement)?.style?.textDecorationLine = TextDecorationLine.None.toString()
    }
    .onMouseLeave {
        (it.currentTarget as? HTMLElement)?.style?.textDecorationLine = TextDecorationLine.Underline.toString()
    }



